module.exports = __webpack_public_path__ + "img/20200324135459TIM截图20200324135414.3cade738.png";